
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBoxBackground } from '@/utils/types'
import cloneDeep from 'lodash/cloneDeep'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Background extends Vue {
  @Prop()
  modelValue!: IFlexMessageBoxBackground

  linearGradient: IFlexMessageBoxBackground = {
    type: 'linearGradient',
    angle: '0deg',
    startColor: '#000000',
    endColor: '#ffffff',
  }

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBoxBackground | undefined) {
    this.$emit('update:modelValue', value)
  }

  get backgroundType() {
    return this.modelValue?.type ?? ''
  }

  set backgroundType(value: string) {
    if (value === 'linearGradient') {
      this.value = cloneDeep(this.linearGradient)
    } else {
      this.value = undefined
    }
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  percentageValidate(val) {
    if (!val) return true

    const match = /^(\d{1,3}(?:\.\d+)?)%$/.exec(val)
    if (!match) return false

    const num = Number(match[1])
    return !(num < 0 || num > 100)
  }

  degValidate(val) {
    if (!val) return true

    const match = /^(\d{1,3}(?:\.\d+)?)deg$/.exec(val)
    if (!match) return false

    const num = Number(match[1])
    return !(num < 0 || num > 360)
  }
}
